import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { to: '/chatbot/settings', label: 'Settings' },
  { to: '/chatbot/install', label: 'Install' },
  { to: '/chatbot/inbox', label: 'Chat Inbox' },
];

const ChatbotSubnav: React.FC = () => {
  const location = useLocation();
  return (
    <nav className="mb-6 border-b border-border pb-3">
      <div className="flex gap-2 overflow-x-auto pb-1">
      {links.map(({ to, label }) => (
        <Link
          key={to}
          to={to}
          className={`shrink-0 px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
            location.pathname === to ||
              (to === '/chatbot/inbox' && location.pathname.startsWith('/chatbot/inbox'))
              ? 'bg-primary text-white'
              : 'text-fg-secondary hover:bg-surface-hover'
          }`}
        >
          {label}
        </Link>
      ))}
      </div>
    </nav>
  );
};

export default ChatbotSubnav;
